<app-dialog-header [title]="'Please answer the question'|translate" (closed)="close(false)"></app-dialog-header>
<div class="modal-body d-flex flex-column gap-2">
    <div class="d-flex flex-column align-items-center">
        <div class="text-black fw-bold text-ellipsis" [title]="data.form.accountName">{{data.form.accountName}}</div>
        <div class="fw-bold">{{data.clientName}}</div>
    </div>
    <form autocomplete="off" novalidate>
        <div class="d-flex flex-column gap-2">
            <ng-container *ngFor="let item of data.form.metadata.form.formFields; let idx = index;">
                <ng-container [ngSwitch]="item.fieldType">
                    <!--text-like info-->
                    <ng-container *ngSwitchCase="'DISPLAY'">
                        <div class="text-black">
                            {{item.label}}
                        </div>
                    </ng-container>
                    <!--checkbox-->
<!--                    <ng-container *ngSwitchCase="'formCheckboxField'">-->
<!--                        <div class="form-group">-->
<!--                            <mat-checkbox-->
<!--                                    [name]="item.fieldType"-->
<!--                                    [(ngModel)]="item.answer"-->
<!--                            >{{item.label}}</mat-checkbox>-->
<!--                        </div>-->
<!--                    </ng-container>-->
                    <!--image-->
                    <ng-container *ngSwitchCase="'IMAGE'">
                        <div class="form-group">
                            <label>{{item.label}}</label>
                            <img [src]="item.src" [alt]="item.label" [style]="item.style">
                        </div>
                    </ng-container>
                    <!--select-->
                    <ng-container *ngSwitchCase="'LIST'">
                        <div class="form-group">
                            <label>{{item.label}}</label>
                            <ng-select
                                    [items]="item.formListOptions"
                                    [name]="(item.label || 'list') + idx"
                                    [(ngModel)]="item.answer"
                                    placeholder="Select Two-Factor Option"
                                    bindLabel="value"
                                    bindValue="key"
                                    id="pet-select"
                            ></ng-select>
                        </div>
                    </ng-container>
                    <!--checkbox list-->
                    <ng-container *ngSwitchCase="'MULTISELECT'">
                        <div class="form-group">
                            <div>{{item.label}}</div>
                            <app-multi-select
                                    bindValue="key"
                                    bindLabel="value"
                                    placeholder="Search and pick values.."
                                    [name]="'multiselect_' + idx"
                                    [items]="item.formListOptions"
                                    [(ngModel)]="item.msAnswer"
                            ></app-multi-select>
                        </div>
                    </ng-container>
                    <!--input field-->
                    <ng-container *ngSwitchCase="
                            ['TEXT', 'PASSWORD', 'TOKEN'].includes(item.fieldType) ? item.fieldType : ''
                        ">
                        <div class="form-group">
                            <label>{{item.label}}</label>
                            <div [class.password-input-wrapper]="item.fieldType === 'PASSWORD'">
                                <input
                                        [type]="item.fieldType === 'PASSWORD' && !isPasswordVisible ? 'password' : 'text'"
                                        [name]="(item.label || 'text') + idx"
                                        [(ngModel)]="item.answer"
                                        class="form-control"
                                        [class.pe-5]="item.fieldType === 'PASSWORD'"
                                        maxlength="{{item.max}}"
                                        minlength="{{item.min}}"
                                        placeholder="{{item.value}}"
                                        required="{{item.mandatory}}"
                                />
                                <button
                                        *ngIf="item.fieldType === 'PASSWORD'"
                                        type="button"
                                        class="password-visibility-toggle"
                                        [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"
                                        [attr.aria-pressed]="isPasswordVisible"
                                        (click)="isPasswordVisible = !isPasswordVisible"
                                >
                                    <i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </form>
</div>
<div class="modal-footer">
    @if (isWaitingForClientResponse) {
        <div class="d-flex align-items-center gap-2 me-auto">
            <span class="text-muted me-auto">{{'Waiting for client response'|translate}}</span>
            <mat-spinner diameter="18"></mat-spinner>
        </div>
    }
    <app-button *ngIf="shouldEnableSms()"
                (click)="onSendSMS()"
                [disabled]="isSendingSms || isWaitingForClientResponse">
        {{'SMS Client'|translate}}
    </app-button>
    <app-button [disabled]="isSendingSms || isWaitingForClientResponse || !canSubmit()" (click)="submit()">
        {{'Submit'|translate}}</app-button>
</div>
